export const IM_PLANT = "IM_PLANT";
export const IM_PLANT_SUCCESS = "IM_PLANT_SUCCESS";
export const IM_PLANT_ERROR = "IM_PLANT_ERROR";